import React from "react";
import { NavLink } from "react-router-dom";
import {Helmet} from 'react-helmet-async';

const Faq = () => {
  return (
    <>
    <Helmet>
      <title>FAQ</title>
      <meta name='description' content="Frequently asked questions about Coimbatore International Airport."/>
      <link rel="canonical" href="/faq"/>
    </Helmet>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Does Coimbatore have 2 airports?
          </h5>
          <p className="card-text">Answer - Coimbatore has only one airport.</p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Which is the nearest airport to Coimbatore airport?
          </h5>
          <p className="card-text">
            Answer - Salem Airport is approximately 173 Kms from Coimbatore
            International Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - When did Coimbatore airport open?
          </h5>
          <p className="card-text">
            Answer - Airport was Constructed in 1940, Coimbatore airport was
            once a civil aerodrome. It reopened in 1987 in its new avatar and
            was modernized to accommodate larger aircrafts like the Boeing 737.
            .
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How far is PSG from Coimbatore Airport?
          </h5>
          <p className="card-text">
            Answer - PSG hospital is Approximately 6 Kms from Coimbatore
            Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What is the name of the airport in Coimbatore?
          </h5>
          <p className="card-text">Answer - Coimbatore International Airport.</p>
        </div>
      </div>


      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What is Coimbatore Airport Pincode?
          </h5>
          <p className="card-text">Answer - Pincode for Coimbatore International Airport is 641014</p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How many flights per day in Coimbatore?
          </h5>
          <p className="card-text">
            Answer - Coimbatore Airport has approximately 24 Departures and 24
            Arrival daily.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How far is Coimbatore airport from city?
          </h5>
          <p className="card-text">
            Answer - Coimbatore Airport is Approximately 10 Kms from the city.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Which airport is nearest to Ooty?
          </h5>
          <p className="card-text">
            Answer - Coimbatore International Airport is nearest to Ooty.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Question - How big is Coimbatore Airport?</h5>
          <p className="card-text">
            Answer - Coimbatore Airport has approximately 24 Departures and 24
            Arrival daily.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How long is the flight from Chennai to CBE?
          </h5>
          <p className="card-text">
            Answer - It takes approximately 1 Hour to reach to Chennai Airport
            from Coimbatore Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How long is the flight from Chennai to CBE?
          </h5>
          <p className="card-text">
            Answer - It takes approximately 1 Hour to reach to Chennai Airport
            from Coimbatore Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How far is Coimbatore from Delhi by flight?
          </h5>
          <p className="card-text">
            Answer - It takes approximately 3 Hour to reach to Delhi Airport
            from Coimbatore Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How far is Isha Foundation from Coimbatore Airport?
          </h5>
          <p className="card-text">
            Answer - ISHA Yoga Center is approximately 40 Kms from Coimbatore
            International Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Does Coimbatore airport have lounge?
          </h5>
          <p className="card-text">
            Answer - Yes, Please contact Duty Airport Terminal Manager on
            0422-2591905 / 9442191902.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Which airport is near to Adiyogi Coimbatore?
          </h5>
          <p className="card-text">
            Answer - Adi Yogi Statue is approximately 40 Kms from Coimbatore
            International Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How many International flights are there in Coimbatore
            Airport?
          </h5>
          <p className="card-text">
            Answer - There are only 2 International Flights from Coimbatore
            Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How long is Coimbatore airport runway?
          </h5>
          <p className="card-text">
            Answer - Coimbatore International Airport runway is approximately 3
            Kms in length.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Which airlines operating from Coimbatore airport?
          </h5>
          <p className="card-text">
            Answer - Indigo, Vistara, AirIndia, Spicejet, Scoot, Air Arabia.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How many hours travelling from Coimbatore Airport to
            Ooty?
          </h5>
          <p className="card-text">
            Answer - It takes approximately 2 to 3 hours to reach Ooty by road
            from Coimbatore International Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How far is Adiyogi from Coimbatore airport?
          </h5>
          <p className="card-text">
            Answer - Adiyogi statue is approximately 40 Kms from Coimbatore
            Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Does Coimbatore have 2 airports?
          </h5>
          <p className="card-text">
            Answer - Coimbatore has only 1 airport i.e. Coimbatore International
            Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How many terminals are there in Coimbatore airport?
          </h5>
          <p className="card-text">
            Answer - Coimbatore Airport has only 1 terminal.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Can I stay in Coimbatore airport overnight?
          </h5>
          <p className="card-text">
            Answer - Please contact Airport Terminal Manager 0422-2591905 /
            9442191902.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Question - Is Coimbatore airport crowded?</h5>
          <p className="card-text">
            Answer - Coimbatore Airport has approximately 24 Departures and 24
            Arrival, daily.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How much is a taxi from Coimbatore airport to Isha
            Foundation?
          </h5>
          <p className="card-text">
            Answer - Taxi Service is available at Coimbatore International
            Airport, you can call 0422-2591905 / 9442191902 for more
            information.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Question - What is Sitra airport?</h5>
          <p className="card-text">
            Answer - Coimbatore International Airport is sometimes called SITRA
            airport due to its proximity to SITRA (South India Textile Research
            Association) junction.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Is any test required for domestic air travel?
          </h5>
          <p className="card-text">
            Answer - Please contact 0422-2591905 / 9442191902 for more
            information on this subject.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Is check in required for domestic flights?
          </h5>
          <p className="card-text">
            Answer - Yes, Check-in is required for Domestic Flights at
            Coimbatore International Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - Which airport is near to Isha Temple?
          </h5>
          <p className="card-text">
            Answer - Coimbatore International Airport is approximately 40 Kms
            from ISHA Yoga Center.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How far is Isha Foundation from Coimbatore airport?
          </h5>
          <p className="card-text">
            Answer - ISHA Yoga Center is approximately 40 Kms from Coimbatore
            International Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - How far is Le Meridien Coimbatore from airport?
          </h5>
          <p className="card-text">
            Answer - Le Marididien is approximately 5.7 Kms from Coimbatore
            Airport.
            <NavLink to="/hotels" type="button" className="btn btn-primary"> All Nearby Hotels</NavLink>
          </p>
        </div>
      </div>


      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What are the Hotels near Coimbatore airport?
          </h5>
          <p className="card-text">
            Answer - Please Visit the Hotels Page on the website.
            <NavLink to="/hotels" type="button" className="btn btn-primary"> All Nearby Hotels</NavLink>
          </p>
        </div>
      </div>


      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What is Coimbatore airport code?
          </h5>
          <p className="card-text">
            Answer - ICAO code for Coimbatore Airport is VOCB and IATA code for Coimbatore Airport is CJB.
            <NavLink to="/" type="button" className="btn btn-primary"> More Information</NavLink>
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What is famous sweet in Coimbatore?
          </h5>
          <p className="card-text">
            Answer - You should try Mysore Pak and many other sweets at
            Coimbatore Airport.
            <NavLink to="/restaurant" type="button" className="btn btn-primary"> Restaurants at Airport</NavLink>
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What is Coimbatore special food?
          </h5>
          <p className="card-text">
            Answer - You should try authentic South Indian Dishes like Idli,
            Dosa at Coimbatore Airport.
            <NavLink to="/restaurant" type="button" className="btn btn-primary"> Restaurants at Airport</NavLink>
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What is the famous fabric of Coimbatore?
          </h5>
          <p className="card-text">
            Answer - Silk is one of the fabric famous in Coimbatore, gift one to
            your loved ones by shopping at Coimbatore Airport.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            Question - What is the famous item of Coimbatore?
          </h5>
          <p className="card-text">
            Answer - Experience the Taste of Food, Touch of Fabric and
            Hospitality of staff at Coimbatore International Airport.
          </p>
        </div>
      </div>
    </>
  );
};

export default Faq;
